var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUaFlag = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2714D2",
  d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7H4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0057B8",
  d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7H4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2714D2",
  d: "M4 12h16v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD800",
  d: "M4 12h16v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUaFlag);
export default ForwardRef;